import React, { useState } from 'react';
import { useMatch } from '../context/MatchContext';

const PENALTY_TYPES = [
  'Attacco dopo kallyo',
  'Uscita bordi',
  'Caduta',
  'Evitare combattimento',
  'Colpire basso',
  'Afferrare/spingere',
  'Altro',
];

function AthletePanel({ onAthleteSelect, onAddPenalty, onDeletePenalty }) {
  const { state, selectAthlete } = useMatch();
  const { currentAction, session, penalties, currentRound } = state;

  const [penaltyType, setPenaltyType] = useState(PENALTY_TYPES[0]);

  const bluePens = penalties.filter(p => p.athlete === 'blue' && p.round_number === currentRound);
  const redPens  = penalties.filter(p => p.athlete === 'red'  && p.round_number === currentRound);

  const handleSelect = (athlete) => {
    selectAthlete(athlete);
    onAthleteSelect(athlete);
  };

  const handleAddPenalty = (athlete) => {
    onAddPenalty({ athlete, penalty_type: penaltyType });
  };

  const handleDeleteLastPenalty = (athlete) => {
    const pens = athlete === 'blue' ? bluePens : redPens;
    if (pens.length === 0) return;
    const last = pens[pens.length - 1];
    onDeletePenalty(last.id);
  };

  const blueName = session?.athlete_blue_name || 'BLU';
  const redName  = session?.athlete_red_name  || 'ROSSO';

  return (
    <div className="panel">
      <div className="panel-header">Atleta</div>
      <div className="panel-body">

        {/* BLU */}
        <div className="panel-section">
          <button
            className={`athlete-select-btn blue${currentAction.athlete === 'blue' ? ' selected' : ''}`}
            onClick={() => handleSelect('blue')}
          >
            <span>BLU</span>
            <span className="athlete-name-label">{blueName}</span>
          </button>
        </div>

        {/* ROSSO */}
        <div className="panel-section">
          <button
            className={`athlete-select-btn red${currentAction.athlete === 'red' ? ' selected' : ''}`}
            onClick={() => handleSelect('red')}
          >
            <span>ROSSO</span>
            <span className="athlete-name-label">{redName}</span>
          </button>
        </div>

        <div className="separator" />

        {/* Tipo penalita */}
        <div className="panel-section">
          <span className="panel-label">Tipo penalita</span>
          <select
            className="form-input"
            value={penaltyType}
            onChange={e => setPenaltyType(e.target.value)}
            style={{ fontSize: 11, padding: '4px 6px' }}
          >
            {PENALTY_TYPES.map(pt => (
              <option key={pt} value={pt}>{pt}</option>
            ))}
          </select>
        </div>

        {/* Penalita BLU */}
        <div className="panel-section">
          <span className="panel-label" style={{ color: 'var(--color-blue-light)' }}>
            Gam-jeom BLU
          </span>
          <div className="penalty-counter">
            <button className="btn btn-sm btn-secondary" onClick={() => handleDeleteLastPenalty('blue')}>-</button>
            <span className="penalty-count blue">{bluePens.length}</span>
            <button className="btn btn-sm btn-primary" onClick={() => handleAddPenalty('blue')}>+</button>
          </div>
          <div style={{ fontSize: 10, color: 'var(--color-text-dim)', textAlign: 'center' }}>
            &rarr; +{bluePens.length}pt a ROSSO
          </div>
        </div>

        {/* Penalita ROSSO */}
        <div className="panel-section">
          <span className="panel-label" style={{ color: 'var(--color-red-light)' }}>
            Gam-jeom ROSSO
          </span>
          <div className="penalty-counter">
            <button className="btn btn-sm btn-secondary" onClick={() => handleDeleteLastPenalty('red')}>-</button>
            <span className="penalty-count red">{redPens.length}</span>
            <button className="btn btn-sm btn-danger" onClick={() => handleAddPenalty('red')}>+</button>
          </div>
          <div style={{ fontSize: 10, color: 'var(--color-text-dim)', textAlign: 'center' }}>
            &rarr; +{redPens.length}pt a BLU
          </div>
        </div>

      </div>
    </div>
  );
}

export default AthletePanel;
